module.exports = __webpack_public_path__ + "img/view.1e6285a7.png";